import { LocalizedContent } from './localized-content';

export class LocalizedContentField {
  constructor(
    public language_code: string,
    public content: string
  ) {
    // @ts-ignore
    if(this.content instanceof LocalizedContent) {
      this.content = this.content.fields[0].content;
    }
  }

  public toString(): string {
    return JSON.stringify({
      language_code: this.language_code,
      content: this.content
    });
  }
}
